import { Injectable, inject } from '@angular/core';
import { LocalStorageService } from '@shared/services/storage/local-storage.service';
import { AppConstant } from '@shared/contants/app.constant';

interface CookieConsentValue {
    necessary: boolean;
    functional: boolean;
    analytics: boolean;
}

@Injectable({ providedIn: 'root' })
export class CookieConsentService {
    private readonly localStorageService = inject(LocalStorageService);

    hasDecision(): boolean {
        const value = this.localStorageService.get(AppConstant.COOKIE_CONSENT_KEY) as CookieConsentValue | null;
        return typeof value?.necessary === 'boolean';
    }

    allowsTracking(): boolean {
        const value = this.localStorageService.get(AppConstant.COOKIE_CONSENT_KEY) as CookieConsentValue | null;
        return value?.analytics === true;
    }

    acceptConsent(): void {
        this.persist({ necessary: true, functional: true, analytics: true });
    }

    rejectConsent(): void {
        this.persist({ necessary: true, functional: false, analytics: false });
    }

    private persist(value: CookieConsentValue): void {
        this.localStorageService.set(AppConstant.COOKIE_CONSENT_KEY, value);
    }
}
